import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { AnalyticsTrigger, Button, Grid, GridColumn, Notice } from 'telia-front-react';
import config from '../../../Config';
import InternetCalculatorStore from '../../../stores/InternetCalculatorStore';
import { TranslationsContext } from '@teliaee/telia-translate';

interface CustomerWithoutElionCustomerIdErrorProps {
  calculatorKey: string;
  internetCalculatorStore?: InternetCalculatorStore;
}

function CustomerWithoutElionCustomerIdError(props: CustomerWithoutElionCustomerIdErrorProps): JSX.Element {
  const translate = React.useContext(TranslationsContext).translate;
  const { calculatorKey, internetCalculatorStore } = props;

  if (!internetCalculatorStore.isCustomerWithoutElionCustomerId(calculatorKey)) {
    return null;
  }

  return (
    <Notice type="error" align="center">
      <Grid align={['middle-xs', 'between-xs']}>
        <GridColumn width={['xs']}>{translate('internetAndTvCalculator.customerWithoutContract')}</GridColumn>
        <GridColumn width={['xs']}>
          <AnalyticsTrigger trigger={{ id: 'Link - Vormistan kliendilepingu', callback: 'onClick' }}>
            <Button
              text={translate('internetAndTvCalculator.registerCustomer')}
              iconRight="#arrow-right"
              url={`${config.teliaWebSelfServiceUrl}/registreerimine`}
            />
          </AnalyticsTrigger>
        </GridColumn>
      </Grid>
    </Notice>
  );
}

export default inject('internetCalculatorStore')(observer(CustomerWithoutElionCustomerIdError));
